import LockIcon from "@mui/icons-material/Lock";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import React, { type ReactNode, useState } from "react";

const SESSION_KEY = "sp-executor-authenticated";

const getCurrentPin = (): string => {
	const now = new Date();
	const hours = now.getHours().toString().padStart(2, "0");
	const minutes = now.getMinutes().toString().padStart(2, "0");
	return `${hours}${minutes}`;
};

type Props = {
	children: ReactNode;
};

export const PinGate = ({ children }: Props) => {
	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
		return sessionStorage.getItem(SESSION_KEY) === "true";
	});
	const [pin, setPin] = useState("");
	const [error, setError] = useState("");

	const handleUnlock = () => {
		if (pin === getCurrentPin()) {
			sessionStorage.setItem(SESSION_KEY, "true");
			setIsAuthenticated(true);
			setError("");
		} else {
			setError("Incorrect PIN. Please try again.");
			setPin("");
		}
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			handleUnlock();
		}
	};

	if (isAuthenticated) {
		return <>{children}</>;
	}

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "60vh",
			}}
		>
			<Paper
				elevation={3}
				sx={{
					p: 4,
					maxWidth: 400,
					width: "100%",
					textAlign: "center",
				}}
			>
				<LockIcon sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
				<Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
					Access Required
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
					Enter PIN to access the SP Executor
				</Typography>
				<TextField
					type="password"
					label="PIN"
					variant="outlined"
					fullWidth
					value={pin}
					onChange={(e) => setPin(e.target.value)}
					onKeyDown={handleKeyDown}
					error={!!error}
					helperText={error}
					sx={{ mb: 2 }}
					autoFocus
				/>
				<Button
					variant="contained"
					fullWidth
					onClick={handleUnlock}
					disabled={!pin}
				>
					Unlock
				</Button>
			</Paper>
		</Box>
	);
};
